import { Component, HostListener, OnInit } from '@angular/core';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { BankDetailsComponent } from './quicktransfer-bankdetails/bankdetails.component';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import $ from 'jquery';


@Component({
  selector: 'app-quicktransfer',
  templateUrl: './quicktransfer.component.html',
  styleUrls: ['./quicktransfer.component.css']
})
export class QuicktransferComponent implements OnInit {
  loading = false;
  currencies: string[];
  countries: string[];
  receiverTypes: string[];
  paymentTypes: string[];
  showDetailsButtonText: string = "Show Details";
  showDetailsFlag: boolean = false;
  showConditionalFlag: boolean = false;
  hasScrolled: boolean = false;
  filter: any = {
    selectedCountry: null,
    selectedCurrency: null,
    selectedPaymentType: null,
    selectedReceiverType: null
  };

  busSenderDetailsMandatory: string[];
  busSenderDetailsConditionalOptional: string[];
  indSenderDetailsConditionalOptional: string[];
  busSenderDetailsOptional: string[];
  indSenderDetailsMandatory: string[];
  indSenderDetailsOptinal: string[];
  bankDetails: string[];
  receiverIndividualDetailsMandatory: string[];
  receiverIndividualDetailsOptinal: string[];
  receiverBusinessDetailsMandatory: string[];
  receiverBusinessDetailsOptinal: string[];
  transactionLimit: string[];
  processingTime: string[];
  transactionType: string[];
  transactionTypeString: String;
  visible = false;
  informationPoint : string[] = [
    'Your payment options e.g. Bank transfers, Wallets, SWIFT payments',
    'The types of payments we support e.g. C2C, B2B',
    'The minimum and maximum transfer limits',
    'The speed of pay, and how soon your funds will be delivered',
    'Receiver details you need to be ready with',
    'Sender details (required, only if you are a financial institution, processing payments on behalf of your customer)'
  ];

  viewType: string;
  v_countries: any;
  v_currencies: any;
  v_paymentTypes: any;
  filterByPaymentType = {
    paymentType: undefined,
    currency: undefined,
    country: undefined,
  };
  filterByCurrency = {
    currency: undefined,
    paymentType: undefined,
    country: undefined,
  };
  filterByCountry = {
    currency: undefined,
    paymentType: undefined,
    country: undefined,
  };

  constructor(private http: HttpClient, private ds: NzDrawerService) {

  }



  ngOnInit(): void {
    this.http.get<any>(environment.apiBase+"/central/corridorspeci/countries/SG").subscribe(resp => {
      this.v_countries = resp;
      this.v_paymentTypes = resp.paymentTypes;
      this.v_currencies = resp.currencies;
    }, err => {
      alert("Error retriving feed");
    });
  }

  @HostListener('window:scroll', ['$event'])
  onScroll(event: Event) {
    
    if ($(window).scrollTop() === 0) {
      this.hasScrolled = false; 
    }
  }

  setViewType(t: string) {
    this.viewType = t;
    if (!this.hasScrolled && $(window).scrollTop() === 0) {
      $('html, body').animate({
        scrollTop: $(window).scrollTop() + 200  
      }, 300);

      this.hasScrolled = true;
    }
  }

  search(type: string) {
    this.loading = true;
    var requestBody = {};
    if (type == 'filterByPaymentType') {
      requestBody = {
        'toCurrency': this.filterByPaymentType.currency,
        'paymentType': this.filterByPaymentType.paymentType,
        'country': this.filterByPaymentType.country
      }
    } else if (type == 'filterByCountry') {
      requestBody = {
        'toCurrency': this.filterByCountry.currency,
        'paymentType': this.filterByCountry.paymentType,
        'country': this.filterByCountry.country
      }
    } else if (type == 'filterByCurrency') {
      requestBody = {
        'toCurrency': this.filterByCurrency.currency,
        'paymentType': this.filterByCurrency.paymentType,
        'country': this.filterByCurrency.country
      }
    }
    const apiUrl = environment.apiBase+'/central/corridorspeci/getAllDetails';
    this.http.post<any[]>(apiUrl, requestBody).subscribe(response => {
      this.showDetailsFlag = true;
      this.busSenderDetailsMandatory = response['busSenderDetails_m'];
      this.indSenderDetailsMandatory = response['indSenderDetails_m'];
      this.receiverIndividualDetailsMandatory = response['ReceiverIndividualDetails_m'];
      this.busSenderDetailsOptional = response['busSenderDetails_o'];
      this.indSenderDetailsOptinal = response['indSenderDetails_o'];
      this.receiverIndividualDetailsOptinal = response['ReceiverIndividualDetails_o'];
      this.receiverBusinessDetailsMandatory = response['ReceiverBusinessDetails_m'];
      this.receiverBusinessDetailsOptinal = response['ReceiverBusinessDetails_o'];
      this.busSenderDetailsConditionalOptional = response['busSenderDetails_co'];
      this.indSenderDetailsConditionalOptional = response['indSenderDetails_co']
      this.bankDetails = response['BankDetails'];
      this.transactionLimit = response['transactionLimit'];
      this.processingTime = response['processingTime'].map(time => time.trim());
      this.loading = false;
      if(this.busSenderDetailsConditionalOptional && this.busSenderDetailsConditionalOptional.length > 0 && this.busSenderDetailsConditionalOptional && this.indSenderDetailsConditionalOptional.length > 0){
        this.showConditionalFlag = true;
      }else{
        this.showConditionalFlag = false;
      }

      
      const transactionTypeJSON = response['transactionType']?.[0];
      if (transactionTypeJSON) {
        try {
          const transactionTypeObj = JSON.parse(transactionTypeJSON);
          this.transactionType = transactionTypeObj.txnTypes;
          this.transactionTypeString = this.transactionType.join(', ');
        } catch (error) {
          console.error('Error parsing transaction types:', error);
          this.transactionType = [];
          this.transactionTypeString = '';
        }
      } else {
        this.transactionType = [];
        this.transactionTypeString = '';
      }
    },
      error => {
        console.error('API error:', error);

      });

  }

  openBankDetails() {
    var d = this.ds.create<BankDetailsComponent, { banks: string[] }, string>({
      nzTitle: 'Bank Names',
      nzContent: BankDetailsComponent,
      nzContentParams: {
        banks: this.bankDetails
      },
      nzWidth: (window.innerWidth / 3) * 2

    });

  }



}
